import { addDays } from 'date-fns';
import ar from 'date-fns/locale/ar';
import { useTranslation } from 'next-i18next';
import { ReactElement } from 'react';
import * as React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.min.css';

import { Typography } from '@/shared/components/atoms';
import {
  addDayHandler,
  getDateFormat,
  isExceedCurrentDay,
  subDayHandler,
} from '@/shared/components/molecules/CustomDatePicker/logic';

import Calender from '~/images/shared/calender.svg';
import LeftArrow from '~/images/shared/leftArrow.svg';
registerLocale('ar', ar);

interface IOnlyDatePickerProps {
  defaultDate?: Date;
  onlyDatePicker?: boolean;
  onChange: (date: Date) => void;
  showIcon?: boolean;
  todayMax?: boolean;
}
/**
 *
 * @defaultDate  {Date} : default selected day if not passed that will be current day
 * @onChange   : {fun(Date)} : when change selected day will call this fun with the new selected day
 * @returns
 */
export default function OnlyDatePicker({
  defaultDate = new Date(),
  onChange,
  showIcon = true,
  todayMax = true,
}: IOnlyDatePickerProps): ReactElement {
  const [date, setDate] = React.useState(defaultDate);
  React.useEffect(() => {
    if (defaultDate) setDate(defaultDate);
  }, [defaultDate]);
  React.useEffect(() => {
    onChange(date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);
  const {
    i18n: { language },
  } = useTranslation();

  // return date picker without days
  return (
    <div className='flex items-center justify-center gap-2'>
      {/* decrease (Day) */}
      <span
        onClick={() => subDayHandler(date, setDate)}
        className='cursor-pointer p-1 text-14 text-primary-default rtl:rotate-180'
      >
        <LeftArrow />
      </span>

      <span>
        <DatePicker
          wrapperClassName='relative '
          calendarClassName='capitalize'
          locale={language}
          selected={date}
          maxDate={todayMax ? new Date() : undefined}
          onChange={(date) => (date ? setDate(date) : null)}
          customInput={
            <Typography
              variant='subtitle2'
              weight='semiBold'
              className='flex cursor-pointer items-center gap-2 capitalize text-primary-default'
            >
              {showIcon && <Calender />}{' '}
              {getDateFormat(date, language, 'd MMMM YYY')}
            </Typography>
          }
        />
      </span>
      {/* increase (Day) */}
      <button
        disabled={todayMax && isExceedCurrentDay(addDays(date, 1))}
        onClick={() => addDayHandler(date, setDate)}
        className=' cursor-pointer p-1 text-14 text-primary-default disabled:pointer-events-none disabled:text-background-disable  ltr:rotate-180 '
      >
        <LeftArrow />
      </button>
    </div>
  );
}
